import React from "react";
import { Drawer } from "rsuite";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOutAlt,
  faHouseUser,
  faPenNib,
} from "@fortawesome/free-solid-svg-icons";

import User from "../userProfile/user.component";
import { ConfirmLogout } from "../Alert/alert.component";
import { toggleDrawerHidden } from "../../Redux/Drawer/drawer.actions";
import Button from "../LogButton/Button";
import "./sideNav.styles.scss";

const SideNav = ({ toggleDrawerHidden, history }) => {
  const close = () => {
    toggleDrawerHidden();
  };
  return (
    <div className="side-nav">
      <Drawer
        placement="left"
        size="xs"
        backdrop={true}
        onHide={close}
        show={true}
        style={DrawerStyle}
      >
        <Drawer.Header>
          <Drawer.Title>TBS OPEN ASSESSMENT</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body
          style={{
            display: "flex",
            flexDirection: "column",
            color: "white",
          }}
        >
          <User />
          <br />
          <Link style={LinkStyle}>
            <FontAwesomeIcon icon={faHouseUser} style={{ marginRight: 10 }} />
            Dashboard
          </Link>
          <Link style={LinkStyle}>
            {" "}
            <FontAwesomeIcon icon={faPenNib} style={{ marginRight: 10 }} />
            ExamHistory
          </Link>
          <Link style={LinkStyle}>
            {" "}
            <FontAwesomeIcon icon={faHouseUser} style={{ marginRight: 10 }} />
            Past Results
          </Link>
          <Link style={LinkStyle}>
            {" "}
            <FontAwesomeIcon icon={faHouseUser} style={{ marginRight: 10 }} />
            Coming soon{" "}
          </Link>
        </Drawer.Body>
        <Drawer.Footer style={{ textAlign: "center", paddingBottom: "3vh" }}>
          <Button onClick={() => ConfirmLogout(history)}>
            <FontAwesomeIcon icon={faSignOutAlt} /> Logout
          </Button>
        </Drawer.Footer>
      </Drawer>
    </div>
  );
};

const LinkStyle = {
  marginTop: 40,
  textDecoration: "none",
  color: "white",
};

const DrawerStyle = {
  flexDireaction: "column",
  fontFamily: "Montserrat",
  display: "flex",
};

const mapDispatchToProps = (dispatch) => ({
  toggleDrawerHidden: () => dispatch(toggleDrawerHidden()),
});

const mapStateToProps = ({ drawer: { Hidden } }) => ({
  Hidden,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SideNav)
);
